<template>
  <div>
    <!-- description -->
    <v-row>
      <v-icon class="material-icons">description</v-icon>
      <div>{{ $t("story.description") }}</div>
    </v-row>
    <v-row >
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card class="description-container-card">
            <div class="description-container">
              <div
                v-html="getText"
                class="elevation-2 description-container__description"
                id="descriptionTextArea"
              />
            </div>
            <v-fade-transition>
              <v-overlay v-if="hover" absolute>
                <v-btn
                  class="editDescriptionButton rounded-xl"
                  @click="toggleDialog(true)"
                  color="primaryAction"
                >
                  {{ $t("story.editDescription") }}
                </v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
      <v-text-field v-model="getText" height=0 style="font-size: 0px; padding: 0"
       />
      <EditDescriptionDialog v-model="dialog" />
    </v-row>
  </div>
</template>
<script>
import EditDescriptionDialog from "@/components/CreatorTools/StoryHub/BasicInfo/EditDescriptionDialog";
import hasDialog from "@/mixins/hasDialog";
import { mapGetters } from "vuex";
export default {
  mixins: [hasDialog],
  computed: {
    ...mapGetters("sharedStoryDescription", ["getText"]),
  },
  components: {
    EditDescriptionDialog,
  }
};
</script>
<style lang="scss" scoped>
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-color: transparent!important;
  border-image: none;
}

</style>